export const ERROR_MESSAGE = 'An unexpected error occurred'
